import { connect } from 'react-redux';
import { withAnalytics } from 'analytics';
import { favoriteStationToggle } from 'actions/favoriteStation-actions';
import { getIsFavoriteStation } from 'store/reducers/favorites';

import FavoriteButton from './FavoriteButton';
import { Station } from 'api/models';

interface stateProps {
  isFavorite: boolean;
  station: Station;
}

interface ownProps extends Station {
  minimalButton?: boolean;
  isFavorite: boolean;
}

interface dispatchProps {
  onFavoriteToggle: (ownProps: Station) => void;
}

const mapStateToProps = (state: stateProps, ownProps: Station) => {
  return {
    isFavorite: getIsFavoriteStation(state, ownProps),
  };
};

const favoriteStationToggleWithAnalytics = withAnalytics(favoriteStationToggle, {
  'player_add-type': 'header',
});

const mapDispatchToProps = {
  onFavoriteToggle: favoriteStationToggleWithAnalytics,
};

function mergeProps(stateProps: stateProps, mapDispatchToProps: dispatchProps, ownProps: ownProps) {
  const { minimalButton } = ownProps;
  const { isFavorite } = stateProps;
  const { onFavoriteToggle } = mapDispatchToProps;

  return {
    isFavorite,
    minimalButton,
    onFavoriteToggle: () => onFavoriteToggle(ownProps),
    ...ownProps,
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FavoriteButton);
